import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { EurosPipe } from '../../../pipes/euros.pipe'

@Component({
    selector: 'case-currency-yield',
    template: `{{ amount | euros }}`,
    styleUrls: ['./currency-yield.component.scss'],
    standalone: true,
    imports: [CommonModule, EurosPipe]
})
export class CurrencyYieldComponent {
  @Input() amount: number
}
